export const liftGroupColor: string[] = ["445E93", "B6174B", "306B34"];
